import { formateNumber } from 'shared/helpers';
export class AuthConverter {
  convertUserData(data) {
    const convertedData = {
      id: data.id,
      email: data.email,
      currency: data.currency,
      firstName: data.first_name,
      lastName: data.last_name,
      role: +data.role,
      isPartner: data.is_partner,
      typePartnerPayment: data.type_partner_payment,
      isWithdrawalAccess: data.is_withdrawal_access,
      isDepositAccess: data?.is_deposit_access ?? true,
      semiAutoWithdrawalEnabled: data?.semi_auto_withdrawal_enabled ?? false,
      username: data.username,
      changedPassword: data.changed_password ?? true,
      isCashbackActive: data.is_cashback_active,
    };
    return convertedData;
  }

  convertBalance(data) {
    const convertedData = {
      balance: formateNumber(data.balance),
      bonusBalance: +data.bonus_balance,
      currency: data.currency,
      isBanned: data.is_banned,
    };
    return convertedData;
  }

  convertCashbackInfo(data) {
    const { is_cashback_active, cashback_conditions_text } = data;
    return { isCashbackActive: is_cashback_active, cashbackConditions: cashback_conditions_text };
  }
}
